import type { Direction } from '@config'

function isDirection(value: string): value is Direction {
  return value === 'N' || value === 'S' || value === 'E' || value === 'W'
}

export function cellKey(x: number, y: number) {
  return `${x},${y}`
}

export function portKey(x: number, y: number, port: Direction) {
  return `${x},${y}:${port}`
}

const parsePortCache = new Map<string, { x: number; y: number; direction: Direction }>()

export function parsePort(portStr: string): { x: number; y: number; direction: Direction } {
  const cached = parsePortCache.get(portStr)
  if (cached) return cached

  const [cell = '0,0', directionRaw = 'N'] = portStr.split(':')
  const [rawX = '0', rawY = '0'] = cell.split(',')

  const x = Number(rawX)
  const y = Number(rawY)
  const direction = isDirection(directionRaw) ? directionRaw : 'N'

  const result = {
    x: Number.isFinite(x) ? x : 0,
    y: Number.isFinite(y) ? y : 0,
    direction,
  }

  parsePortCache.set(portStr, result)
  return result
}
